import { useEffect } from 'react';

import {
  isClientHydrated,
  setClientHydrated,
} from '#/rendering/state/renderingState';

export function SetClientHydratedGlobalHandler() {
  useEffect(() => {
    if (!isClientHydrated()) setClientHydrated();
  }, []);

  return null;
}
